/**
 * 视频空间存储占用统计。
 * 按采集/素材/回收站拆分字节数，并复用图片空间的容量展示格式化函数。
 */
import { normalizePositiveByteSize } from '@/utils/imageSpaceByteSize';
import { isVideoSpaceCollectionSource } from './videoSpaceMeta';

/**
 * 从单条视频记录解析字节大小（依次尝试 size、fileSize、byteSize 字段）。
 *
 * @param {object|null|undefined} video 视频记录
 * @returns {number} 非负字节数，无法解析时为 0
 */
export function resolveVideoByteSize(video) {
  const fields = [video?.size, video?.fileSize, video?.byteSize];
  for (const raw of fields) {
    const n = normalizePositiveByteSize(raw);
    if (n != null) return n;
  }
  return 0;
}

/**
 * 对视频列表按来源与删除状态汇总存储占用。
 *
 * @param {object[]|null|undefined} videos 视频记录列表
 * @returns {{ collectionBytes: number, materialBytes: number, trashBytes: number, totalBytes: number }}
 */
export function computeVideoSpaceStorageBreakdown(videos) {
  const list = Array.isArray(videos) ? videos : [];
  let collectionBytes = 0;
  let materialBytes = 0;
  let trashBytes = 0;

  for (const video of list) {
    const bytes = resolveVideoByteSize(video);
    if (!bytes) continue;
    // 1. 已删除计入回收站
    if (video.deletedAt) {
      trashBytes += bytes;
      continue;
    }
    // 2. 活跃记录按 source 区分采集与素材
    if (isVideoSpaceCollectionSource(video.source)) {
      collectionBytes += bytes;
    } else {
      materialBytes += bytes;
    }
  }

  const totalBytes = collectionBytes + materialBytes + trashBytes;
  return {
    collectionBytes,
    materialBytes,
    trashBytes,
    totalBytes,
  };
}

export { formatStorageBytesLabel, formatStorageMbLabel, calcStoragePercent } from './imageSpaceStorageStats';
